module.exports = __webpack_public_path__ + "static/media/bg-2.d3ef9291.png";